import { useRouter } from '@application/utils';
import { CountryCode } from '@gql/graphql';
import { Container, RelatedLinks } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { useMemo } from 'react';
import type { FC } from 'react';
import medal from '@assets/medal_blue.svg';
import * as Styled from './styled';
import type { FooterProps } from './types';

export * from './types';

export const Footer: FC<FooterProps> = (props) => {
  const { categories, rows, internalLinks } = props;
  const { translate } = useTranslation();
  const { country } = useRouter();

  const columns = useMemo(() => {
    return categories.map((category, index) => {
      if (category.links.length) {
        return (
          <Styled.Column key={index}>
            <Styled.ColumnTitle>{category.title}</Styled.ColumnTitle>
            {category.links.map((link, linkIndex) => (
              <Styled.ColumnLink
                clickable={(!!link.link || !!link.onClick).toString()}
                to={link.link}
                onClick={link.onClick}
                key={linkIndex}
              >
                {link.label}
              </Styled.ColumnLink>
            ))}

            <Styled.ColumnChildren>{category.children}</Styled.ColumnChildren>
          </Styled.Column>
        );
      }
      return null;
    });
  }, [categories]);

  const footerRows = useMemo(() => {
    return rows.map((row, index) => (
      <Styled.Row key={index}>
        {row.links.map((link, linkIndex) => (
          <Styled.RowLink
            clickable={(!!link.link || !!link.onClick).toString()}
            onClick={link.onClick}
            key={linkIndex}
            to={link.link}
          >
            {link.label}
          </Styled.RowLink>
        ))}
      </Styled.Row>
    ));
  }, [rows]);

  return (
    <footer>
      {!!internalLinks && <RelatedLinks categories={internalLinks} />}
      <Styled.Banner>
        <Styled.BannerIcon src={medal} />
        {country.toUpperCase() === CountryCode.BE
          ? translate('common.banners.specialized.belgium')
          : translate('common.banners.specialized.generic')}
      </Styled.Banner>
      <Styled.TopWrapper>
        <Container>
          <Styled.ColumnContainer>{columns}</Styled.ColumnContainer>
        </Container>
      </Styled.TopWrapper>

      <Styled.BottomWrapper>
        <Container>{footerRows}</Container>
      </Styled.BottomWrapper>
    </footer>
  );
};
